import { InfusionCalculator } from '@/components/InfusionCalculator';

const Index = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white">
      <InfusionCalculator />
    </div>
  );
};

export default Index;
